import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { UserIntegrationsContext } from "contexts/UserIntegrations";
import { useContext } from "react";

import { getPageName } from "constants/trackingProps";
import { trackEvent } from "utils/tracking";

const CustomDomainSection = () => {
  const { currentUser } = useContext(OrganizationUserContext);
  const { setCustomDomainDialog, subscription } =
    useContext(SubscriptionContext);
  const { userIntegration } = useContext(UserIntegrationsContext);
  const customDomainExample = () => {
    return `ugcby${currentUser?.name.split(" ")[0].toLowerCase()}.com`;
  };

  const customEmailExample = () => {
    return `hello@${customDomainExample()}`;
  };

  if (userIntegration?.isCustomDomain || subscription?.customEmailData?.id) {
    return <></>;
  }

  return (
    <Card elevation={2} sx={{ backgroundColor: "#E9F1EA", mb: 3 }}>
      <CardActionArea
        onClick={() => {
          trackEvent("Set up a Professional Email Button Clicked", {
            Source: getPageName(),
          });
          setCustomDomainDialog(true);
        }}
      >
        <CardContent>
          <Typography gutterBottom variant="h6" component="div">
            Set up a Professional Email
          </Typography>
          <Typography color="textSecondary" paragraph>
            Get a professional Gmail inbox with your own domain (i.e.{" "}
            {customEmailExample()}). An email with your own domain will appear
            more professional, reduce the chances of getting blocked or marked
            as spam, and improve your email deliverability.
          </Typography>
          <Button
            size="small"
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}
            disableElevation
          >
            Get started
            <Box
              component="i"
              className="fa-solid fa-envelope"
              sx={{ ml: 1 }}
            />
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CustomDomainSection;
